import React, { useState } from 'react';
import { FormattedDate, FormattedNumber } from 'react-intl'
import { StyleInlineFkTable, StyledPropotionalNavLink } from './../../../../Styling/styledTable/StyledTable';
import UseTableSorter from '../../../../components/useTable/UseTable'
import usePaginator from '../../../../components/useTable/UsePaginator'
import { fixMissingTimeFromDate } from '../../../../util/date/dateRoutines';

const ExpandedEiendomTable = (props) => {

    const localeMessages = props.localeMessages
    const shareOfOwnership = props.shareOfOwnership

    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('j');    // feltnavn
    const [currentType, setCurrentType] = useState('datetime'); // num

    // state for grid paginator
    const [numberPrPage, setNumberPrPAge] = useState(10000)
    const [activePage, setActivePage] = useState(1);


    const [t1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Point to data 
    const eiendomData = props.tableData;

    // Setupt paginator
    // eslint-disable-next-line no-unused-vars
    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        eiendomData.sort(t1GetSortFunc().fn), // <==== sorting inputdata =========
        numberPrPage, setNumberPrPAge,
        activePage, setActivePage
    )

    function multiplyValues(a, b) {
        const toNumber = (v) => {
            if (typeof v === 'number') return v;
            if (typeof v === 'string') {
            let str = v.trim();

            const isPercent = str.endsWith('%');
            if (isPercent) {
                str = str.slice(0, -1);
            }

            str = str.replace(/\s+/g, '');

            const hasComma = str.includes(',');
            const hasDot   = str.includes('.');
            if (hasComma && hasDot) {
                str = str.replace(/\./g, '').replace(',', '.');
            } else if (hasComma) {
                str = str.replace(',', '.');
            }
            
            const parsed = parseFloat(str);
            if (isNaN(parsed)) {
                throw new Error(`Invalid number: "${v}"`);
            }
            return isPercent ? parsed / 100 : parsed;
            }
            throw new Error(`Unsupported type: ${typeof v}`);
        };

        const numA = toNumber(a);
        const numB = toNumber(b);
        const result = numA * numB;

        const [intPart, decPart] = result.toString().split('.');
        const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return decPart
            ? `${formattedInt}.${decPart}`
            : formattedInt;
    }


    const printHeader = () => {
        return (
            <thead>
                <tr>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >Nr</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{localeMessages['GH_heftelseId']}</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{localeMessages['GH_heftelseType']}</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >Jur.grunnlag</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >Direkte ansvar</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >Flere eiendommer</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)', textAlign: "right", paddingRight: 50 }} >{localeMessages['GH_sharePant']}</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)', textAlign: "right", paddingRight: 50 }} >{localeMessages['GH_ownPant']}</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)', textAlign: "right", paddingRight: 50 }} >{localeMessages['GH_totalPant']}</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)', textAlign: "right", paddingRight: 50 }} >{localeMessages['GH_estimatedSharePant']}</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)', textAlign: "right", paddingRight: 50 }} >{localeMessages['GH_estimatedTotalPant']}</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{localeMessages['GH_currency']}</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >Oppd.dato</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >Reg.dato</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >Rett.haver type</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >Rett.haver navn</th>
                    <th style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >Rett.haver orgid</th>
                </tr>
            </thead>
        )
    }

    const printRow = (model) => {

        const asDate = (val) => {
            // Tomt felt om det er noe krøll med val, ellers blir dagens dato satt inn som default
            if (val === null || val === '' || val === undefined) {return (<></>)};
            // Kludge fordi FireFox ikke godtar dato uten tid uten videre
            let valok = fixMissingTimeFromDate(val)
            return (
                <FormattedDate value={valok} day="2-digit" month="2-digit" year="numeric" />
            )
        }

        return (
            <>
                <tr key={model.j + 10000} style={{ backgroundColor: 'white' }}>

                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.j + 1}</td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.id}</td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.type}</td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.legalFoundation}</td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.directResponsibility}</td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.registeredOnMultipleProperties}</td>
                    <td align='right' style={{ paddingRight: 50, fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{shareOfOwnership}</td>
                    <td align='right' style={{ paddingRight: 50, fontSize: 'clamp(14px, 0.65vw, 20px)' }} >
                        {multiplyValues(
                            shareOfOwnership,
                            model.amounts[0]?.amount ?? 0
                        )}
                    </td>
                    <td align='right' style={{ paddingRight: 50, fontSize: 'clamp(14px, 0.65vw, 20px)' }}>
                        {model.amounts[0]?.amount}
                    </td>
                    <td align='right' style={{ paddingRight: 50, fontSize: 'clamp(14px, 0.65vw, 20px)' }}>
                        {multiplyValues(
                            shareOfOwnership,
                            model.amounts[0]?.estimatedRemainingAmount ?? 0
                        )}
                    </td>
                    <td align='right' style={{ paddingRight: 50, fontSize: 'clamp(14px, 0.65vw, 20px)' }}>
                        {model.amounts[0]?.estimatedRemainingAmount}
                    </td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.amounts[0]?.currency}</td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.updatedDate}</td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.registeredDate}</td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.rightsHolders[0]?.type}</td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.rightsHolders[0]?.name}</td>
                    <td style={{ fontSize: 'clamp(14px, 0.65vw, 20px)' }} >{model.rightsHolders[0]?.organisationId}</td>
                </tr>
            </>
        )
    }

    return (
        <>

            <StyleInlineFkTable>
                {printHeader()}

                <tbody>
                    <Paginate>
                        {/* paginate forventer en funksjon */}
                        {row => printRow(row)}
                    </Paginate>
                </tbody>
            </StyleInlineFkTable>

        </>
    )
}

export default ExpandedEiendomTable